<template>
  <div class="opera-payReport">
    <topNav :title="$t('payReport_title')"></topNav>
    <datepik @change='getDate' ref="datepik" limit="pre" step="1"></datepik>
<!--    <div class="ssearch">-->
<!--      <switchbtn checked='swith'-->
<!--                 @change="switchChange"-->
<!--                 :title1="$t('payReport_title1')"-->
<!--                 :title2="$t('payReport_title2')"></switchbtn>-->
<!--    </div>-->
    <div class="formTop" :class='{formTopFix:formPosition==true}'>
      <div class="topOne" style='text-align: left;width:35%'><span class="firstTh">{{$t('cashierReport_project')}}</span></div>
      <div class="topOne" style='text-align: right;width:15%'><span>{{$t('revenueReport_quantity')}}</span></div>
      <div class="topOne" style='text-align: right;width:25%'><span>{{$t('revenueReport_daily')}}</span></div>
      <div class="topOne" style='text-align: right;width:25%'><span>{{$t('revenueReport_month')}}</span></div>
    </div>
    <div class="chartform">
      <table style="width: 100%;table-layout: fixed; " class="tbodyH">
        <tr>
          <th style="width:35%"></th>
          <th style="width:15%"></th>
          <th style="width:25%"></th>
          <th style="width:25%"></th>
        </tr>
        <template v-for="(item,index) in report">
          <tr v-if="index == 0" class="sum" :key="index">
            <td class="title">{{item.descript}}</td>
            <td>{{item.quantity}}</td>
            <td>{{item.amt_today | toThousands}}</td>
            <td>{{item.amt_month | toThousands}}</td>
          </tr>
          <tr v-else :key="index">
            <td class="title">{{item.descript}}</td>
            <td>{{item.quantity}}</td>
            <td>{{item.amt_today | toThousands}}</td>
            <td>{{item.amt_month | toThousands}}</td>
          </tr>
        </template>
        <tr style="width:100%;height:0.8rem;"></tr>
      </table>
      <nothing :condition="report != null && report.length == 0"></nothing>
    </div>
  </div>
</template>
<script>
  import datepik from "../operaCommon/datepik";
  import moment from 'moment'
  import nothing from '../operaCommon/nothing'
  import switchbtn from '../operaCommon/switch'
  import {Toast} from 'mint-ui';
  import _ from 'lodash'

  export default {
    data() {
      return {
        seachOption: {
          code: '',//酒店范围代码（空时取当前）
          d: null,//日期（空时当前营业日）
          level: '',//酒店范围代码（可空）
          name: '',//i酒店范围的名称
          type: 'fee'
        },
        hotelName: '',
        swith: false,
        report: {},
        shirt: {},
        user: {},
        formPosition: false,//默认tab不固定
      }
    },
    mounted() {
      this.getData();
      //监听该页面滚动条
      document.getElementsByClassName('opera-payReport')[0].addEventListener('scroll', this.boxScroll)
    },
    methods: {
      //滚动条上拉下滑顶部固定事件
      boxScroll() {
        var pxScoll = document.getElementsByClassName('opera-payReport')[0].scrollTop;
        this.scrollTop = pxScoll / 37.5;
        var tbodyHeight = document.getElementsByClassName('tbodyH')[0].clientHeight / 37.5;
        var viewTbodyHeight = document.getElementsByClassName('opera-payReport')[0].clientHeight / 37.5;
        //   console.log(this.scrollTop);
        //判断实际表格内容是否比表格直观视图大一些
        if (tbodyHeight > viewTbodyHeight - 1) {
          if (this.scrollTop > 2.5) {
            this.formPosition = true
          } else {
            this.formPosition = false
          }
        } else {
          this.formPosition = false;
        }
      },
      //生命周期结束后自动执行销毁监听事件
      destroyed() {
        document.getElementsByClassName('opera-payReport')[0].removeEventListener('scroll', this.boxScroll)
      },
      getData() {
        this.$http.post('/mobilepmsapi/opera/report/getReport4', this.seachOption).then(res => {
          if (res.data.result == 0) {
            this.report = res.data.retVal.data;
            this.seachOption.d = moment(res.data.retVal.search.d).format('YYYY-MM-DD');

            this.$refs.datepik.setDate(moment(res.data.retVal.search.d).toDate());
            this.hotelName = res.data.retVal.name;
          } else {
            Toast({
              message: res.data.msg,
              position: 'bottom',
              duration: 3000
            });
          }
        })
      },
      switchChange(value) {
        // console.log(value)
        this.seachOption.type = value ? "pay" : 'fee';
        this.getData();
      },

      getDate(time) {
        this.seachOption.d = time;
        // console.log(time)
        this.getData()
      },
      getHotel(hotel) {
        this.seachOption.code = hotel.code;
        this.seachOption.level = hotel.level;
        this.seachOption.name = hotel.descript;
        // console.log(hotel.code)
        this.getData()
      },
    },
    filters: {
      toThousands(num) {
        return num.toFixed(2).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
      }
    },
    components: {
      datepik,
      nothing,
      switchbtn
    }
  }
</script>
<style lang='less'>
  .opera-payReport {
    background-color: #F6F8F9;
    height: 100vh;
    min-height: 100%;
    overflow: auto;

    .formTop {
      width: 100%;

      .topOne {
        width: 25%;
        height: 1.0133rem;
        color: #fff;
        background-color: #f69c2d;
        display: inline-block;
        text-align: center;
        line-height: 1.0133rem;
        float: left;
        font-weight: bold;

        span {
          padding-right: 0.3rem;
        }

        .firstTh {
          padding-left: 0.3rem;
        }
      }
    }

    .formTopFix {
      position: fixed;
      top: 1.04rem;
      z-index: 200;
    }

    .ssearch {
      // margin: 10px auto;
      // margin-left:4rem;
      margin: 0.2667rem auto;

    }

    .chartform {
      width: 100%;
      margin: 0 auto;

      table {
        width: 100%;

        .sum {
          background: rgb(247, 239, 140);
          color: red
        }

        th {
          // height: 1.0133rem;
          color: #fff;
          background-color: #F69C2D;
          width: 20%;
        }

        .title {
          font-weight: bold;
          text-align: left;
          padding-left: 0.3rem;
        }

        td {
          // height: 1.0933rem;
          text-align: right;
          word-wrap: break-word;
          width: 25%;
          padding: 0.3733rem 0.3rem 0.3733rem 0;

          .icon-shangsheng {
            position: relative;
            left: -0.2667rem;
            line-height: 1.0933rem;
            color: #FF485F;
          }

          .icon-xiajiang {
            position: relative;
            left: -0.2667rem;
            line-height: 1.0933rem;
            color: #249F17;
          }
        }
      }
    }

    .flip-list-enter {
      background-color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// payReport.vue?5f6ba952